import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  VULNERABILITIES_FEATURE_KEY,
  VulnerabilitiesState,
} from './vulnerabilities.reducer';

export const selectVulnerabilityState =
  createFeatureSelector<VulnerabilitiesState>(VULNERABILITIES_FEATURE_KEY);

export const getVulnerabilities = createSelector(
  selectVulnerabilityState,
  (state) => {
    return state.vulnerabilities || [];
  },
);

export const getVulnerabilitiesOptions = createSelector(
  selectVulnerabilityState,
  (state) => {
    const { hasMore, pageNumber, pageSize, totalCount, totalPages } = state;
    return {
      pageNumber,
      pageSize,
      totalCount,
      totalPages,
      hasMore,
    };
  },
);

export const getVulnerabilityAssociatedEntities = createSelector(
  selectVulnerabilityState,
  (state) => {
    return state.associatedEntities || null;
  },
);

export const getVulnerabilityById = createSelector(
  selectVulnerabilityState,
  (state) => {
    return state.vulnerabilityById || null;
  },
);

export const getIsLoading = createSelector(
  selectVulnerabilityState,
  (state) => {
    return state.isLoading;
  },
);

export const getIsResoveUnResolveLoading = createSelector(
  selectVulnerabilityState,
  (state) => {
    return state.isResoveUnResolveLoading;
  },
);

export const getVulnerabilitiesAssets = createSelector(
  selectVulnerabilityState,
  (state) => {
    return state.vulnerabilitiesAssets || [];
  },
);

export const getVulnerabilityOccurences = createSelector(
  selectVulnerabilityState,
  (state) => {
    return state.occurences || [];
  },
);
